var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-4"},[_c('p',{staticClass:"title is-4 has-text-dark"},[_vm._v("Thank you!")]),_c('p',{staticClass:"subtitle is-6 has-text-primary"},[_c('span',[_vm._v(" Our dedicated support team has received your request and will be investigating it shortly. We aim to get back to you by email within 24 hours. ")])])])
}]

export { render, staticRenderFns }